import axios, { AxiosError } from 'axios';
import { AppError } from 'merchant-api';

export const checkout = axios.create({
  baseURL: import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL'],
  withCredentials: true
});

checkout.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) throw AppError.Unauthenticated;
    if (error.response?.status === 403) throw AppError.Unauthenticated;
    return Promise.reject(error);
  }
);

export * from './getCheckoutState/getCheckoutState'
export * from './startCheckout/startCheckout'
export * from './getContract/getContract'
export * from './getDisclosure/getDisclosure'
export * from './getBankDetails/getBankDetails'
export * from './validateBankAccount/validateBankAccount'
export * from './getIdentityQuestions/getIdentityQuestions'
export * from './getIdentityQuestions/getIdentityChallengeQuestions'
export * from './postIdentityAnswers/postIdentityAnswers'
export * from './postIdentityAnswers/postIdentityChallengeAnswers'
export * from './completeCheckout/completeCheckout'
export * from './nextCheckout/generateDocuments'
export * from './updateBankInfo/updateBankInfo'
export * from './updateFirstDrawAmount/updateFirstDrawAmount'
export * from './useBankInfo/useBankInfo'
export * from './voidCheckouts/voidCheckouts'